import { config } from "../configs/config";
import axios from "axios";
import { supabase } from "../configs/supabase-config";
import { isValid } from "../utils";
import { removeDuplicates } from "../utils/helper";

export const playlist = {
    create: async (streamId, userId) => { },
    rename: async (streamId, userId) => { },
    update: async (streamId, userId) => { },
    delete: async (streamId, userId) => { },
    addItem: async (streamId, userId) => { },
    removeItem: async (streamId, userId) => { },
};